interface CurrencyLableProps {
    value?: number|string|null,
}

const CurrencyLable: React.FC<CurrencyLableProps> = ({ value }) => {
    return <>{value ? `$${value}` : '$0.00'}</>
};

export default CurrencyLable;
